import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SERVER_API_URL} from 'src/app/app.constants';
import {IScopeMySuffix} from 'src/app/shared/model/scope-my-suffix.model';
import {createRequestOption} from 'src/app/shared/util/request-util';


type EntityResponseType = HttpResponse<IScopeMySuffix>;
type EntityArrayResponseType = HttpResponse<IScopeMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class ScopeMySuffixService {
    private resourceUrl = SERVER_API_URL + 'api/scopes';
    private resourceUrlView = SERVER_API_URL + 'api/scopes/view';
    private resourceUrlForRule = SERVER_API_URL + 'api/scopes/rule';

    constructor(private http: HttpClient) {}

    create(scope: IScopeMySuffix): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(scope);
        return this.http
            .post<IScopeMySuffix>(this.resourceUrl, copy, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    update(scope: IScopeMySuffix): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(scope);
        return this.http
            .put<IScopeMySuffix>(this.resourceUrl, copy, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IScopeMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }
    findForViewScope(id: number): Observable<HttpResponse<any>> {
        return this.http
            .get<IScopeMySuffix>(`${this.resourceUrlView}/${id}`, { observe: 'response' })
            .map((res: HttpResponse<any>) => this.convertDateFromServer(res));
    }
    findOneTimeScopedataForRule(id: number, certificateRequestId: number): Observable<EntityResponseType> {
        return this.http
            .get<IScopeMySuffix>(`${this.resourceUrlForRule}/${id}/${certificateRequestId}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    findScopedataForRule(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IScopeMySuffix>(`${this.resourceUrlForRule}/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IScopeMySuffix[]>(this.resourceUrl, { params: options, observe: 'response' })
            .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    private convertDateFromClient(scope: IScopeMySuffix): IScopeMySuffix {
        const copy: IScopeMySuffix = Object.assign({}, scope, {
            effectiveDate: scope.effectiveDate != null ? scope.effectiveDate.toJSON() : null,
            expiryDate: scope.expiryDate != null ? scope.expiryDate.toJSON() : null
        });
        return copy;
    }

    private convertDateFromServer(res: EntityResponseType): EntityResponseType {
        res.body.effectiveDate = res.body.effectiveDate != null ?  new Date(res.body.effectiveDate) : null;
        res.body.expiryDate = res.body.expiryDate != null ?  new Date(res.body.expiryDate) : null;
        return res;
    }

    private convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
        res.body.forEach((scope: IScopeMySuffix) => {
            scope.effectiveDate = scope.effectiveDate != null ?  new Date(scope.effectiveDate) : null;
            scope.expiryDate = scope.expiryDate != null ?  new Date(scope.expiryDate) : null;
        });
        return res;
    }

    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<IScopeMySuffix>(`${this.resourceUrl}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }

    findRulesByScopeIdAndExtension(scopeId: number,extension): Observable<any> {
        return this.http.post<IScopeMySuffix>(SERVER_API_URL+'api/scope-rule-by-id-and-extension/'+scopeId,extension, { observe: 'response' });
    }
    
    deleteExtensionsFromRulesByScopeIdAndExtension(scopeId: number,extension): Observable<any> {
        return this.http.post<IScopeMySuffix>(SERVER_API_URL+'api/delete-extension-from-rule-by-id-and-extension/'+scopeId,extension, { observe: 'response' });
    }

}
